import { useEffect, useState } from "react";
import RadioField from "../../../common/interactive/RadioField";

export default function RadioOption({filtersValues, options, item, mainSelectAction, classes, workQ}) {

    const [hideItem, setHideItem] = useState(false)
    useEffect(() => {
        if (workQ && workQ.filter_conditions) {
            if (workQ.filter_conditions[`${item.key}_filter_type`] && workQ.filter_conditions[`${item.key}_filter_type`] == 1) { //we have a rigid filter!!!
                setHideItem(true)
            }
        }
    }, [workQ, item])
    const rawChecked = filtersValues?.[item.key]
    const defaultChecked = (rawChecked === undefined || rawChecked === null || rawChecked === '') && item.key === 'hiof_selected'
        ? 'all'
        : rawChecked

    return <>
        {!hideItem && <div className={classes.row}>
            <p className={classes.label}>{item.label}</p>
            <RadioField defaultChecked={defaultChecked} fields={options} name={item.key} identifier={{type: item.key}} action={mainSelectAction}/>
        </div>}
    </>
}